
import { Options, Vue } from 'vue-property-decorator';
import NButton from '@/uikit/buttons/NButton.vue';

@Options({
  components: { NButton },
  emits: ['close']
})
export default class VideoWallPageSidebar extends Vue {
  dispatchCloseEvent(): void {
    this.$emit('close');
  }
}
